import type {
  IToolbarItemConfigTiptap,
  IToolbarSettings,
  PublisherProvider,
  ToolbarButtonRenderers,
} from './../../../ricos-types';
import { TOOLBARS } from './../../../editor-common';

import type { Topics } from '../../topics';
import type { ToolbarServices } from '../../types';
import { RicosToolbar } from '../ricos-toolbar';
import { mobileItemsRenderers } from './mobile-renderers';

export class MobileToolbar extends RicosToolbar<TOOLBARS.MOBILE> {
  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    publishers: PublisherProvider<Topics>,
    settings: IToolbarSettings<TOOLBARS.MOBILE>,
    shouldCreate: boolean
  ) {
    super(isMobile, services, TOOLBARS.MOBILE, publishers, settings);
    this.isEmpty = () => !shouldCreate;
  }

  getToolbarItemsConfig(options?: { disabled: boolean }): IToolbarItemConfigTiptap[] {
    return (
      this.services.plugins
        ?.getTextButtons()
        .toToolbarItemsConfig(
          this.type,
          this.isMobile,
          this.services.editor.getPublicCommands(),
          this.services.editor.adapter.tiptapEditor,
          options
        ) || []
    );
  }

  getMegaToolbarItemsConfig(options?: { disabled: boolean }): IToolbarItemConfigTiptap[] {
    // TODO: remove separators
    return this.getToolbarItemsConfig(options).filter(
      item => !['UNDO', 'REDO', 'addPlugin'].includes(item.id)
    );
  }

  getToolbarItemsRenderers(
    _referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    return mobileItemsRenderers;
  }
}
